module.exports = __webpack_public_path__ + "static/media/YF34_0.28c83a7e.jpg";